import { getVariationFillColor } from '@gonfalon/flag-variations/getVariationFillColor';
import type { List, Map } from '@gonfalon/immutable-shim/immutableShim';
import clsx from 'clsx';

import { VARIATION_NOT_FOUND } from '#components/InstructionList/instructionListUtils';
import Variation from '#components/Variation';
import type { ExperimentRollout } from '#utils/flags/records/Rollout';
import type { Variation as variationType } from '#utils/flags/records/Variation';

import styles from './styles.module.css';

export const ExperimentRolloutDescription = ({
  rolloutWeights,
  variations,
  experimentAllocation,
}: {
  rolloutWeights: Map<string, number>;
  variations: List<variationType>;
  experimentAllocation: ExperimentRollout;
}) => {
  const renderVariation = (index: number) => (
    <Variation
      className={clsx(styles.variationInstructionEntry, 'u-ml-s')}
      key={index}
      color={getVariationFillColor(index)}
      value={
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        variations.get(index)!.getDisplay() /* eslint-enable @typescript-eslint/no-non-null-assertion */
      }
    />
  );

  let total = 0;

  return (
    <span className={styles.RolloutDescription}>
      {rolloutWeights
        .map((value, variationID) => {
          const variationIndex = variations.findIndex((v) => v._id === variationID);
          total += value;
          const percent = value / 1000;
          return (
            <span className={styles.rolloutVariation} key={variationID}>
              {variationIndex >= 0 ? renderVariation(variationIndex) : ` ${VARIATION_NOT_FOUND}`} ({percent}%),
            </span>
          );
        })
        .valueSeq()}
      <span className={styles.rolloutVariation}>
        {` and remaining ${(100000 - total) / 1000}% to `}
        {typeof experimentAllocation.defaultVariation === 'number'
          ? renderVariation(experimentAllocation.defaultVariation)
          : VARIATION_NOT_FOUND}
      </span>
      <span className={styles.rolloutVariation}>
        {` and ${experimentAllocation.canReshuffle ? 'users can be reshuffled' : 'users cannot be reshuffled'}.`}
      </span>
    </span>
  );
};
